import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-auto-auth',
  templateUrl: './auto-auth.component.html',
  styleUrls: ['./auto-auth.component.scss']
})
export class AutoAuthComponent implements OnInit {

  constructor(private router: Router, private route: ActivatedRoute) { }

  ngOnInit() {
    const existingKey = localStorage.getItem('key');

    if (!existingKey) {
      // Get the key from the current route (example.com/auth/<key>)
      const keyFromUrl = this.route.snapshot.paramMap.get('key');

      if (keyFromUrl) {
        localStorage.setItem('key', keyFromUrl);
        //console.log('Key from URL:', keyFromUrl);
      }
    }

    // Redirect to /login
    this.router.navigate(['/login']);
  }

}
